import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import parse from 'html-react-parser';
import newsLocal from '../data/news.json';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Blog = (props) => {
  const { i18n } = useTranslation();
  const [data, setData] = useState({});
  const [content, setContent] = useState("");
  const [isMarkdown, setIsMarkdown] = useState(false);
  
  const lng = i18n.language.substring(0, 2).toLowerCase();

  useEffect(() => {
    const localArticle = newsLocal.find((a) => a.id === props.match.params.id);

    if (localArticle) {
      const translation = localArticle.translation.find((tr) => tr.language.toLowerCase() === lng) || localArticle.translation[0];
      setData({
        title: translation.title,
        image: localArticle.image,
      });

      const articleFile = translation.file;
      setIsMarkdown(articleFile.endsWith('.md'));

      fetch(process.env.PUBLIC_URL + articleFile)
        .then((res) => res.text())
        .then((text) => {
          const cleaned = text.replace(/^---[\s\S]*?---/, '').trim();
          setContent(cleaned);
        });
    } else {
      // Fallback to remote article (legacy behaviour)
      const remoteLng = lng === "it" ? "it" : lng === "es" ? "/es/" : lng === "pt" ? "/pt-br/" : "";
      axios
        .get("https://www.crmpokermagia.com/api/v1/news/" + props.match.params.id + "/" + remoteLng)
        .then((res) => {
          setData(res.data.response);
          setContent(res.data.response.description || "");
          setIsMarkdown(false);
        });
    }
  }, [lng, props.match.params.id]);

  return (
    <>
      <Navbar />
      <section style={{marginTop: 150, marginBottom: 100, textAlign: "center"}}>
        <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* News pictures hidden (Nov 2026) — uncomment to restore the cover.
                {data.image && <img src={data.image} alt={data.title} className="img-fluid" />} */}
                <h1 style={{ fontSize: '2.5rem', lineHeight: '1.2', marginTop: '2rem' }}>{data.title}</h1>
              </div>
            </div>
            <div className="row" style={{textAlign: "left"}}>
              <div className="col-lg-12 mt-5">
                {/* News pictures hidden (Nov 2026): images inside the article body are dropped
                    too. To restore, go back to <ReactMarkdown>{content}</ReactMarkdown> : parse(content). */}
                {isMarkdown ? (
                  <ReactMarkdown disallowedElements={["img"]}>{content}</ReactMarkdown>
                ) : (
                  parse(content, { replace: (node) => (node.name === "img" ? <></> : undefined) })
                )}
              </div>
            </div>
        </div>
      </section>
       

      <Footer />
    </>
  );
};

export default Blog;
